import { SERVICE_FIELD_KEYS } from '~/components/AiSearchChips/ServicesChips/serviceGrammar';
import { ALLOWED_AGREEMENT_BILLED_UPON, ALLOWED_AGREEMENT_DISCOUNT_TYPE, ALLOWED_AGREEMENT_PRICING_TYPE, ALLOWED_AGREEMENT_RECURRENCE, ALLOWED_PRICE_INCREASE_START_ON_TYPE } from '~/types/api/agreements-search';
const DRAFTS_ONLY_FIELDS = new Set([
    'limitedTimeDiscountOffer',
    'startBillingAt'
]);
const AGREEMENTS_SERVICE_FIELDS = new Set(SERVICE_FIELD_KEYS.filter((field)=>!DRAFTS_ONLY_FIELDS.has(field)));
// WHY: the add-filter menu seeds these five with an empty set, so their chip has to render before
// the user has picked anything (ANCR-2411 req 7); every other field needs a value to earn a chip.
const AGREEMENTS_SEEDABLE_FIELDS = new Set([
    'name',
    'recurrence',
    'billedUpon',
    'automaticState',
    'completionState'
]);
export const AGREEMENTS_SERVICE_FIELD_GRAMMAR = {
    allowed: {
        billedUpon: ALLOWED_AGREEMENT_BILLED_UPON,
        recurrence: ALLOWED_AGREEMENT_RECURRENCE,
        pricingType: ALLOWED_AGREEMENT_PRICING_TYPE,
        discountType: ALLOWED_AGREEMENT_DISCOUNT_TYPE,
        startOnType: ALLOWED_PRICE_INCREASE_START_ON_TYPE
    },
    fields: AGREEMENTS_SERVICE_FIELDS,
    seedableFields: AGREEMENTS_SEEDABLE_FIELDS
};
